// extracted by mini-css-extract-plugin
export default {"container":"home_container__Q+zPO","bg-video":"home_bg-video__ZTiti","link":"home_link__8Zeua"};